require('./brokerTransferPensionPlansInternalStep1.scss');

const PropTypes = require('prop-types');

// @Utilities

// @vendors
const React = require('react');
const { FormattedText, formatText } = require('core/i18n').i18n;

// @Components
const DropdownPlans = require('components/broker/brokerDropdownPlans/dropdownPlans');
const { LoadingSection } = require('commonsComponents/loadingSection');
const { OKBoxTitle } = require('commonsComponents/OKBoxTitle');
const BrokerTransferPensionPlansSummary = require('components/commons/broker/brokerTransferPensionPlansDataSummary/brokerTransferPensionPlansDataSummary');


class BrokerTransferPensionPlansInternalStep1 extends React.Component {

    buildDropDown() {
        const {
            immStep, 
            immPlans,
            onSelectPlan
        } = this.props;
        const originPlan = immStep.getIn(['originPlanData', 'internalId']);
        const label = formatText('brokerTraspassBetweenMyPlans-step1Title');
        let error = !immStep.get('validOriginPlan');
        let enabled = !immStep.get('isFetching');
        let errorMsg = formatText('brokerTraspassBetweenMyPlans-step1ErrorNoPlanSelected');
        if(immPlans.length == 0) {
            error = true;
            enabled = false;
            errorMsg = formatText('brokerTraspassBetweenMyPlans-step1ErrorNoPlansInWallet');
        } 

        return (
            <DropdownPlans
                id="broker-origin-plans"
                immPlans={immPlans}
                isOriginPlan={true}
                currentPlanId={originPlan}
                onPlanChange={onSelectPlan}
                error={error}
                label={label}
                errorMsg={errorMsg}
                enabled={enabled}
            />
        )
    }

    buildPlanData() {
        const { immStep } = this.props;
        const originPlan = immStep.get('originPlanData');

        let content;

        if(immStep.get('isFetching')) {
            content = (
                <LoadingSection />
            );
        } else if(originPlan && (immStep.get('success') || immStep.get('notFound'))) {
            content = (
                <BrokerTransferPensionPlansSummary
                    originPlanData={originPlan} 
                /> 
            )
        }
        
        return content;
    }

    render(){
        return (
            <div className="broker-transfer-pension-plans-internal-step1">
                <OKBoxTitle
                    className="broker-transfer-pension-plans-internal-step1__title"
                    value={formatText('brokerTraspassBetweenMyPlans-step1Title')} />
                <div className="broker-transfer-pension-plans-internal-step1__info">
                    <FormattedText value="brokerTraspassBetweenMyPlans-step1SelectPlanA" />
                </div>
                <div className="broker-transfer-pension-plans-internal-step1__dropdown">
                    {this.buildDropDown()}
                </div>
                <div className="broker-transfer-pension-plans-internal-step1__summary">
                    {this.buildPlanData()} 
                </div>
            </div>
        )
    }
}

BrokerTransferPensionPlansInternalStep1.propTypes = {
    immStep: PropTypes.object.isRequired,
    immPlans: PropTypes.object.isRequired,
    onSelectPlan: PropTypes.func.isRequired
}

module.exports = BrokerTransferPensionPlansInternalStep1;